import { render } from "./AprilFoolModal.vue?vue&type=template&id=59e6e67d&scoped=true&ts=true&lang=pug"
import script from "./AprilFoolModal.vue?vue&type=script&lang=ts"
export * from "./AprilFoolModal.vue?vue&type=script&lang=ts"

import "./AprilFoolModal.vue?vue&type=style&index=0&id=59e6e67d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e6e67d"]])

export default __exports__